<template>
  <v-container fluid>
    <span>{{ $t('app.uploads.clickBelowToUpload') }}</span>
    <div class="img-border">
      <div class="img-container">
        <Upload
          @fileSelect="handleFile"
          ref="fileInputProfile"
          hidden
        />
        <img
          v-if="!nurse.upload || !nurse.upload.blobUri"
          id="upload-image"
          class="profile-picture"
          src="@/assets/images/nophoto.png"
          :alt="
            `Profile picture of ${nurse.firstName}`
          "
          @click="selectProfilePicture"
        />
        <!-- Auto rotate -->
        <auto-rotate v-else>
          <img
            id="upload-image"
            class="profile-picture"
            :src="nurse.upload.blobUri"
            :alt="
              `Profile picture of ${nurse.firstName}`
            "
            @click="

                $modal.show('profile-pic-menu-modal')
            "
          />
        </auto-rotate>
        <p style="color:red" v-if="error">{{ error }}</p>
        <modal
          class="menu"
          name="profile-pic-menu-modal"
          width="100%"
          height="auto"
        >
          <ListItem
            border="1px solid #31b9be"
            @click.native="selectProfilePicture"
          >{{ $t("app.picture.edit") }}</ListItem
          >
          <ListItem
            border="1px solid #31b9be"
            last="true"
            @click.native="deleteProfilePicture"
          >{{ $t("app.picture.delete") }}</ListItem
          >
        </modal>
      </div>
      <span
        :style="
          `background-image: url(${require(`@/assets/icons/heart-pink.svg`)})`
        "
        class="mark"
      ></span>
    </div>

    <div>
      <div class="error" v-if="error">
        <p>{{ error }}</p>
      </div>

      <div class="field">
        <InputField
          v-model="form.email"
          :labelTitle="$t('dash.nurse.form-email')"
          required
          placeholder="email@email.com"
          margin="0 auto 25px auto"
          ref="name"
        ></InputField>

        <InputField
          v-model="form.firstName"
          :labelTitle="$t('dash.nurse.form-firstname')"
          :placeholder="$t('dash.nurse.form-firstname')"
          margin="0 auto 25px auto"
          ref="name"
        ></InputField>

        <InputField
          v-model="form.lastName"
          :labelTitle="$t('dash.nurse.form-lastname')"
          :placeholder="$t('dash.nurse.form-lastname')"
          margin="0 auto 25px auto"
        ></InputField>

        <InputField
          v-model="form.nickName"
          :labelTitle="$t('dash.nurse.form-nickname')"
          :placeholder="$t('dash.nurse.form-nickname')"
          margin="0 auto 25px auto"
          required
        ></InputField>

        <InputField
          v-model="form.phone"
          :errorMessage="phoneError"
          @input="onPhoneInput"
          :labelTitle="$t('app.temp-home.phone')"
          type="tel"
          :placeholder="$t('app.temp-home.phone')"
          margin="0 auto 25px auto"
        ></InputField>

        <TextAreaField
          v-model="form.bio"
          :labelTitle="$t('dash.nurse.form-bio')"
          :placeholder="$t('dash.nurse.form-bio-placeholder')"
          :rows="3"
        ></TextAreaField>


        <v-divider class="ma-5"></v-divider>

        <div class="settings-section ml-5 mr-5">
          <label class="checkbox-container mb-5">{{ $t('app.editProfile.languages') }}</label>
          <ListItem
            class="list-item"
            :last="index == languages.length - 1 ? true : false"
            v-for="(lang, index) in languages"
            :key="lang"
            @click.native="updateDisplayLanguage(lang)"
            :highlighted="lang === $i18n.locale ? true : false"
          >
            <span>{{ $t(`general.languages.${lang}`) }}</span>
            <span v-if="lang === $i18n.locale" class="icon check-pink">
          <img :src="require('@/assets/icons/check-pink.svg')" class="icon" />
        </span>
          </ListItem>
        </div>


        <LoadingButton v-if="loading"></LoadingButton>
        <div v-else>
          <p class="green" v-if="inviteSuccessful">{{ $t('dash.nurse.inviteSent') }}</p>
          <p class="red" v-if="requiredNeededError">{{ $t('dash.nurse.requiredNeededError') }}</p>

          <Button
            width="200"
            :title="$t('dash.nurse.action-save')"
            style="margin: 16px 0"
            @click.native="writeNurse('edit')"
          ></Button>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import {neoparentNurses, neoparentUploads, neoparentUsers} from "@/api";
import {getSupportedLocales, redirect} from "@/helpers";

export default {
  props: [],
  name: "neoparent-dashboard-profile",
  computed: {
    canSave: function () {
      if (!this.form.nickName)
        return false
      return true
    }
  },
  data() {
    return {
      error: "",
      phoneError: "",
      form: {
        email: "",
        firstName: "",
        lastName: "",
        nickName: "",
        bio: "",
        phone: "",
        language: ""
      },
      languages: [],
      language: null,
      requiredNeededError: false,
      nurse: {},
      loading: false,
      inviteSuccessful: false
    };
  },
  mounted() {
    this.nurse = this.$store.getters.user
    this.form.email = this.nurse.email;
    this.form.firstName = this.nurse.firstName;
    this.form.lastName = this.nurse.lastName;
    this.form.nickName = this.nurse.nickName;
    this.form.bio = this.nurse.bio;
    this.form.phone = this.nurse.phone;
    this.form.language = this.nurse.language

    this.languages = getSupportedLocales("", this.$store.getters.user.language)
  },
  methods: {
    onPhoneInput(value) {
      if (this.phoneError && (!value || /^[0-9+\-\s()]+$/.test(value))) {
        this.phoneError = "";
      }
    },
    updateDisplayLanguage(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem("locale", lang);
      this.form.language = lang
    },

    deleteProfilePicture(){
      this.nurse.upload = null
      this.nurse.uploadId = null
      this.$modal.hide("profile-pic-menu-modal");
    },
    async handleFile(files) {
      let file = files[0];
      if (file) {
        const formData = new FormData()
        formData.append("file", file, file.name)
        formData.append("access", file.access)
        formData.append("mimeType", file.type)
        formData.append("isProfilePicture", true)

        const res = await neoparentUploads.uploadFile(formData)

        if (Object.keys(this.nurse).length === 0){
          this.nurse = { upload: res.data.data }
        } else {
          this.nurse.upload = res.data.data
        }
      }
    },
    selectProfilePicture() {
      console.log("Selected")
      this.$modal.hide("profile-pic-menu-modal");
      this.$refs.fileInputProfile.$el.click();
    },

    selectImage() {
      this.consoleLog(this.$refs);
    },
    async writeNurse(action) {
      if (action !== "add" && action !== "edit") return;
      if (!this.canSave){
        this.requiredNeededError = true;
        return;
      }

      this.phoneError = "";
      if (this.form.phone && !/^[0-9+\-\s()]+$/.test(this.form.phone)) {
        this.phoneError = this.$t("error.phone.invalid");
        return;
      }

      this.loading = true;

      const data = {
        firstName: this.form.firstName,
        lastName: this.form.lastName,
        nickName: this.form.nickName,
        bio: this.form.bio,
        hospitalId: this.$store.getters.user.hospital.id,
        uploadId: this.nurse.upload ? this.nurse.upload.id : null,
        email: this.form.email,
        phone: this.form.phone,
        language: this.form.language
      };
      this.consoleLog(data);

      // Edit nurse
      this.consoleLog("Updating nurse");
      data.id = this.nurse.id;
      await neoparentNurses
        .editNurse(this.nurse.id, data)
        .then(result => {
          this.loading = false;
          this.consoleLog(result);
          redirect(document.referrer)
        })
        .catch(err => {
          this.loading = false;
          this.error = err.response.data.message;
          window.scrollTo(0, 0);
          this.consoleLog(err);
        });
    },
  }
};
</script>

<style scoped lang="scss">
.loggedin-notice {
  color: #979797;
}

.img-border {
  width: 200px;
  background: #d9f0ea;
  border-radius: 5px;
  height: 200px;
  overflow: hidden;
  margin: 24px auto;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.img-container {
  overflow: hidden;
  border-radius: 50%;
  width: 75%;
  height: 75%;
  margin: auto;
}

.img-border img {
  width: 100%;
  height: 100%;
}

input {
  display: none;
}

label {
  cursor: pointer;
}

.mark {
  background-color: transparent;
  background-size: 100%;
  width: 56px;
  height: 56px;
  padding: 0;
  position: absolute;
  bottom: 0;
  right: 0;
}

.profile-menu {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
}

/* -webkit-overflow-scrolling only exists for ios */
@supports (-webkit-overflow-scrolling: touch) {
  .profile-menu {
    justify-content: space-around; /* space-evenly doesn't work on ios */
  }
}

.profile-picture {
  object-fit: cover;
}

#img-preview {
  margin: 25px auto;
  width: 200px;
  max-height: 200px;
  border: 1px solid #e05484;
}
</style>
